module.exports = __webpack_public_path__ + "img/sport-21-@1x.e64e4a8c.png";